import {createApp} from 'vue';
import initForTests from './init-for-tests';
import initDirectives from './vue-directives';
import {initVuex} from '../../store/global-store';
import {initModalsComponent} from '../../components';
import {registerFilters} from './filters';

const createVueApp = (rootComponent, rootProps) => {
    const app = createApp(rootComponent, rootProps);

    app.config.compilerOptions.isCustomElement = (tag) => {
        return tag === 'smart-script';
    };

    initForTests(app);
    initDirectives(app);
    initVuex(app);
    initModalsComponent(app);
    registerFilters(app);

    return app;
};

export default createVueApp;
